







import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: false
    },
    message: {
      type: String,
      required: false
    }
  }
});
